<div class="store-container">
  <div class="note">
    Los productos estarán listos para entrega 15 días después de su compra.
  </div>
  <div class="row">
    <div class="column" *ngFor="let producto of productos; let i = index">
      <div class="product-card">
        <img [src]="'assets/img/' + getImageFileName(i)" alt="{{ producto.descripcion }}" [routerLink]="['./', producto.idProducto]" style="cursor: pointer;">
        <p>{{ producto.descripcion }}</p>
        <p>Precio: <strong>$ {{ producto.precioPublico }}</strong> MX</p>
        <p>Código: {{ producto.codigo }}</p>
        <button [routerLink]="['./', producto.idProducto]">Adquirir</button>
      </div>
    </div>
  </div>
</div>
